"use strict";

angular.module(ApplicationConfiguration.applicationModuleName).factory("User", [
  "$resource",
  "$stateParams",
  "apiSettings",
  function ($resource, $stateParams, apiSettings) {
    return $resource(
      apiSettings.baseUri + "v1/internal/users/:id",
      { id: "@id" },
      {
        list: {
          method: "GET",
          isArray: false,
          params: {
            page: 1,
            pageSize: apiSettings.defaultPageSize,
            keyword: "",
          },
        },
        current: {
          url: apiSettings.baseUri + "v1/internal/users/current",
          method: "GET",
          isArray: false,
        },
        listIds: {
          url: apiSettings.baseUri + "v1/internal/users/list/ids",
          method: "GET",
          isArray: true,
        },
        listSalesTeam: {
          url: apiSettings.baseUri + "v1/internal/users/list/salesteam",
          method: "GET",
          isArray: true,
          params: {
            page: 1,
            pageSize: apiSettings.defaultPageSize,
          },
        },
        invite: {
          url: apiSettings.baseUri + "v1/internal/users/invite",
          method: "POST",
        },
        inviteSignup: {
          url: apiSettings.baseUri + "v1/internal/users/invite-signup",
          method: "POST",
        },
        inviteValidate: {
          url:
            apiSettings.baseUri +
            "v1/internal/users/invite-validate/:authCodeGuid",
          method: "POST",
          params: {
            authCodeGuid: "@authCodeGuid",
          },
        },
        insert: {
          method: "POST",
        },
        update: {
          method: "PUT",
        },
        delete: {
          method: "DELETE",
        },
      }
    );
  },
]);
